import { put, race, cancelled, takeEvery, join, select, call, putResolve } from 'redux-saga/effects'
import { joinChannel, partChannel } from 'api/Api'
import { CHANNEL_DATA } from 'CHANNEL_DATA'
import { createSagasActions } from 'utils/sagas'
import { push } from 'index'
import {
  init as initState,
  setLoadStatus
} from '../redux/view'
import fetchView from './fetchView'
import viewError from 'store/sagas/viewError'
import channelData from './channelData'

export const NAMESPACE = 'KanBo/MyBoard/sagas/'
export const FETCH_VIEW = NAMESPACE + 'FETCH_VIEW'
export const FETCH_CALENDAR_ITEMS = NAMESPACE + 'FETCH_CALENDAR_ITEMS'
export const FETCH_DATES = NAMESPACE + 'FETCH_DATES'
export const REQUEST_ADD_LIST = NAMESPACE + 'REQUEST_ADD_LIST'
export const REQUEST_ADD_USER_TO_MYBOARD = NAMESPACE + 'REQUEST_ADD_USER_TO_MYBOARD'
export const REQUEST_CHANGE_CARD_CUSTOM_DATE = NAMESPACE + 'REQUEST_CHANGE_CARD_CUSTOM_DATE'
export const REQUEST_CHANGE_CARD_DUE_DATE = NAMESPACE + 'REQUEST_CHANGE_CARD_DUE_DATE'
export const REQUEST_CHANGE_CARD_START_DATE = NAMESPACE + 'REQUEST_CHANGE_CARD_START_DATE'
export const REQUEST_CHANGE_LIST_NAME = NAMESPACE + 'REQUEST_CHANGE_LIST_NAME'
export const REQUEST_CHANGE_LIST_SETTINGS = NAMESPACE + 'REQUEST_CHANGE_LIST_SETTINGS'
export const REQUEST_CHANGE_SETTINGS = NAMESPACE + 'REQUEST_CHANGE_SETTINGS'
export const REQUEST_IMPORT_CARDS = NAMESPACE + 'REQUEST_IMPORT_CARDS'
export const REQUEST_POSITION_CARD = NAMESPACE + 'REQUEST_POSITION_CARD'
export const REQUEST_POSITION_LIST = NAMESPACE + 'REQUEST_POSITION_LIST'
export const REQUEST_REMOVE_ALL_CARDS_FROM_LIST = NAMESPACE + 'REQUEST_REMOVE_ALL_CARDS_FROM_LIST'
export const REQUEST_REMOVE_LIST = NAMESPACE + 'REQUEST_REMOVE_LIST'
export const REQUEST_REMOVE_USER_FROM_MYBOARD = NAMESPACE + 'REQUEST_REMOVE_USER_FROM_MYBOARD'

let { getSagas, actionCreators } = createSagasActions([
  [CHANNEL_DATA, 'channelData', require('./channelData').default],
  [FETCH_VIEW, 'fetchView', require('./fetchView').default],
  [FETCH_CALENDAR_ITEMS, 'fetchCalendarItems', require('./fetchCalendarItems').default, { takeLatest: true }],
  [FETCH_DATES, 'fetchDates', require('./fetchDates').default],
  [REQUEST_ADD_LIST, 'requestAddList', require('./requestAddList').default],
  [REQUEST_ADD_USER_TO_MYBOARD, 'requestAddUserToMyBoard', require('./requestAddUserToMyBoard').default],
  [REQUEST_CHANGE_CARD_CUSTOM_DATE, 'requestChangeCardCustomDate', require('./requestChangeCardCustomDate').default],
  [REQUEST_CHANGE_CARD_DUE_DATE, 'requestChangeCardDueDate', require('./requestChangeCardDueDate').default],
  [REQUEST_CHANGE_CARD_START_DATE, 'requestChangeCardStartDate', require('./requestChangeCardStartDate').default],
  [REQUEST_CHANGE_LIST_NAME, 'requestChangeListName', require('./requestChangeListName').default],
  [REQUEST_CHANGE_LIST_SETTINGS, 'requestChangeListSettings', require('./requestChangeListSettings').default],
  [REQUEST_CHANGE_SETTINGS, 'requestChangeSettings', require('./requestChangeSettings').default],
  [REQUEST_IMPORT_CARDS, 'requestImportCards', require('./requestImportCards').default],
  [REQUEST_POSITION_CARD, 'requestPositionCard', require('./requestPositionCard').default],
  [REQUEST_POSITION_LIST, 'requestPositionList', require('./requestPositionList').default],
  [REQUEST_REMOVE_ALL_CARDS_FROM_LIST, 'requestRemoveAllCardsFromList', require('./requestRemoveAllCardsFromList').default],
  [REQUEST_REMOVE_LIST, 'requestRemoveList', require('./requestRemoveList').default],
  [REQUEST_REMOVE_USER_FROM_MYBOARD, 'requestRemoveUserFromMyBoard', require('./requestRemoveUserFromMyBoard').default]
])

export const sagaActions = actionCreators

export function * onStartSaga ({ userId, myBoardId }) {
  const state = yield select()

  if (state.kanbo.currentUser.id !== userId) {
    yield call(joinChannel, 'vboard-' + myBoardId)
  }
}

export function * onStopSaga ({ userId, myBoardId }) {
  const state = yield select()

  if (state.kanbo.currentUser.id !== userId) {
    yield call(partChannel, 'vboard-' + myBoardId)
  }
}

export function * myBoardActionsListener () {
  try {
    yield race([
      ...getSagas(),
    ])
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  }
}

export function * init ({ userId }) {
  const state = yield select()

  const currentUserId = state['view-myboard'].view.userId

  try {
    yield put(initState({
      userId,
      isLoading: true,
      isLoaded: false,
      changed: userId !== currentUserId
    }))

    const forkedChannelDataListener = yield takeEvery(CHANNEL_DATA, channelData)

    yield fetchView({ payload: { userId }})

    const state = yield select()
    const myBoardId = state['view-myboard'].view.id

    yield call(onStartSaga, { userId, myBoardId })

    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: true
    }))

    yield join(forkedChannelDataListener)
  } catch (error) {
    if (error.code === 700) { // MyBoards are disabled
      yield put(push(state['view-home'].view.lastVisitedUrl || '/'))
    } else if (error.code === 401 || error.code === 402) {
      const state = yield select()
      yield putResolve(viewError({
        text: state.kanbo.locale.messages['MYBOARD_DOES_NOT_EXIST']
      }))
    } else if (error.code === 601) {
      const state = yield select()
      yield putResolve(viewError({
        text: state.kanbo.locale.messages['MYBOARD_ACCESS_DENIED']
      }))
    } else {
      yield putResolve(viewError({
        error,
        refresh: true
      }))
    }

    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))
  } finally {
    if (yield cancelled()) {
      const state = yield select()
      const myBoardId = state['view-myboard'].view.id

      yield call(onStopSaga, { userId, myBoardId })
    }
  }
}
